import React from 'react';
import wingitDesign from '../designSystem';

export default function WingitPublicPage({
  children,
  rightActionLabel,
  onRightAction,
}) {
  const s = wingitDesign.publicPages;

  return (
    <div style={s.page}>
      {rightActionLabel && (
        <div style={styles.actionRow}>
          <button
            type="button"
            onClick={onRightAction}
            style={s.topButton}
          >
            {rightActionLabel}
          </button>
        </div>
      )}

      {children}
    </div>
  );
}

const styles = {
  actionRow: {
    maxWidth: 1180,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
};